import styled from 'styled-components'
import { hideVisually } from 'polished'
import { type ReactNode, type HTMLAttributes } from 'react'

type Props = { children: ReactNode } & HTMLAttributes<HTMLElement>

export function VisuallyHidden({ children, ...rest }: Props) {
  return <Hidden {...rest}>{children}</Hidden>
}

const Hidden = styled.span`
  ${hideVisually}
`
